<template>
    <component :is="layout">
        <router-view></router-view>
    </component>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
const routerIsReady = ref(false);

const layout = computed(() => {
    if (!routerIsReady.value) return 'default-layout';
    return route.meta.layout ?? 'default-layout';
})

router.isReady().then(() => routerIsReady.value = true);
</script>

<style scoped>

</style>